<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Local P.Fee</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" v-model="local_purchase_fee" type="text" placeholder="Local purchase fee" :class="{ 'is-danger': errors.local_purchase_fee }">
                    <span class="icon is-left">
                       <i class="fas fa-hand-holding-usd"></i>
                    </span>
                    <p v-if="errors.local_purchase_fee" class="help is-danger">{{ errors.local_purchase_fee[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            local_purchase_fee: {
                get() {
                    return this.$store.getters.getNewPricePlan.local_purchase_fee
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'local_purchase_fee', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/LocalPurchaseFee.vue